<template>
  <div class="profile-page">
    <!-- 顶部用户信息卡片 -->
    <div class="user-header">
      <div class="header-bg">
        <!-- <div class="setting-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </div>
        <div class="share-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="9" y1="9" x2="15" y2="9"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div> -->
      </div>
      <div class="user-info">
        <img :src="userInfo.avatar" class="avatar" alt="" />
        <div class="info-text">
          <h2 class="username">{{ userInfo.name }}</h2>
          <div class="tags">
            <!-- <img src="@/assets/ok.png" class="okk" alt="">
            <img src="@/assets/no.png" class="noo" alt="">
            <span  class="tag vip">中国烟草有限公司</span> -->
            <span v-if="userInfo.memberType === 'PERSONAL'" class="tag vip">{{ personalStatusText }}</span>
            <img v-else-if="userInfo.companyApplyState == 1" src="@/assets/ok.png" class="okk" alt="">
            <img v-else src="@/assets/no.png" class="noo" alt="">
            <span v-if="userInfo.companyName" class="tag vip">{{userInfo.companyName}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 数据统计卡片 -->
    <div class="stats-card" :class="{ personal: userInfo.memberType === 'PERSONAL' }">
      <div class="stat-item">
        <p class="num orange">{{count.registeredTournamentCount || 0}}</p>
        <p class="label">已报名活动</p>
      </div>
      <div class="stat-item" v-if="userInfo.memberType !== 'PERSONAL'">
        <p class="num blue">{{ count.publishedDemandCount || 0 }}</p>
        <p class="label">已发布需求</p>
      </div>
      <div class="stat-item" v-if="userInfo.memberType !== 'PERSONAL'">
        <p class="num green">{{ count.publishedSupplyCount || 0 }}</p>
        <p class="label">已发布供应</p>
      </div>
      <!-- <div class="stat-item">
        <p class="num purple">256</p>
        <p class="label">积分</p>
      </div> -->
    </div>

    <!-- 我的活动 -->
    <div class="menu-section">
      <p class="section-title">我的活动</p>
      <div class="menu-list">
        <div class="menu-item" @click="goUserActivity()">
          <div class="icon-wrap orange">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff7d00" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <span class="text">已报名的活动</span>
          <span class="badge orange">{{count.registeredTournamentCount || 0}}</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <!-- <div class="menu-item">
          <div class="icon-wrap green">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <span class="text">已参加的活动</span>
          <span class="badge green">8</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div> -->
      </div>
    </div>

    <!-- 供需管理 -->
    <div class="menu-section" v-if="userInfo.memberType !== 'PERSONAL'">
      <p class="section-title">供需管理</p>
      <div class="menu-list">
        <div class="menu-item" @click="goUserDemand()">
          <div class="icon-wrap blue">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1677ff" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          <span class="text">我发布的需求</span>
          <span class="badge blue">{{ count.publishedDemandCount || 0}}</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="menu-item" @click="goUserSupply()">
          <div class="icon-wrap purple">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#722ed1" stroke-width="2">
              <path d="M20 7h-3a2 2 0 0 1-2-2V2"></path>
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9"></path>
              <path d="M12 19V5"></path>
            </svg>
          </div>
          <span class="text">我发布的供应</span>
          <span class="badge purple">{{ count.publishedSupplyCount || 0}}</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <!-- <div class="menu-item">
          <div class="icon-wrap yellow">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#faad14" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
          </div>
          <span class="text">我的收藏</span>
          <span class="badge yellow">23</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div> -->
      </div>
    </div>

    <!-- 联盟信息 -->
    <!-- <div class="menu-section">
      <p class="section-title">联盟信息</p>
      <div class="menu-list">
        <div class="menu-item">
          <div class="icon-wrap purple">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#722ed1" stroke-width="2">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </div>
          <div class="text-wrap">
            <span class="text">已加入联盟</span>
            <span class="sub-text">长三角产业协同创新联盟</span>
          </div>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="menu-item">
          <div class="icon-wrap cyan">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#13c2c2" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div class="text-wrap">
            <span class="text">联盟成员</span>
            <span class="sub-text">共128家企业成员</span>
          </div>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="menu-item">
          <div class="icon-wrap red">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f5222d" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          <div class="text-wrap">
            <span class="text">联盟动态</span>
            <span class="sub-text">3条新消息</span>
          </div>
          <span class="dot"></span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
    </div> -->

    <!-- 其他 -->
    <!-- <div class="menu-section">
      <p class="section-title">其他</p>
      <div class="menu-list">
        <div class="menu-item">
          <div class="icon-wrap gray">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <span class="text">消息中心</span>
          <span class="badge red">6</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="menu-item">
          <div class="icon-wrap gray">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <span class="text">帮助中心</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="menu-item">
          <div class="icon-wrap gray">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </div>
          <span class="text">关于我们</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
    </div> -->

    <!-- 退出登录 -->
    <!-- <div class="logout-btn" @click="handleLogout">退出登录</div> -->
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      userInfo: {
        name: '张明远',
        avatar: 'https://picsum.photos/100/100?random=99',
        isVip: true,
        companyName:'',
        companyApplyState:null,
        memberType:'',
        personalApplyState:null,
      },
      count:{}
    }
  },
  mounted () {
    this.$ajax.get('/api/user/current').then((res) => {
      if(res.data.code == 200){
        sessionStorage.setItem('userInfo',JSON.stringify(res.data.data))
        this.userInfo.avatar = res.data.data.avatarUrl
        this.userInfo.name = res.data.data.nickname
        this.isVip = res.data.data.vip
        this.userInfo.companyName = res.data.data.companyName
        this.userInfo.companyApplyState = res.data.data.companyApplyState
        this.userInfo.memberType = res.data.data.memberType
        this.userInfo.personalApplyState = res.data.data.personalApplyState
      }
    })    
    this.getInfo()
  },
  computed: {
    personalStatusText() {
      if (this.userInfo.personalApplyState === 1) return '个人用户'
      if (this.userInfo.personalApplyState === 2) return '个人用户申请未通过'
      return '个人申请审核中'
    }
  },
  methods: {
    getInfo(){
      this.$ajax.get('/api/user/stats').then((res) => {
        if(res.data.code == 200){
          this.count = res.data.data
        }
      })
    },
    goUserActivity(){
      this.$router.push('/useractivity')
    },
    goUserDemand(){
      this.$router.push('/userdemand')
    },
    goUserSupply(){
      this.$router.push('/usersupply')
    }
  }
}
</script>

<style scoped>
.profile-page {
  background: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 100px;
}

/* 顶部用户信息 */
.user-header {
  background: #ff7d00;
  color: #fff;
  padding-bottom: 20px;
}
.header-bg {
  height: 120px;
  position: relative;
}
.setting-btn, .share-btn {
  position: absolute;
  top: 20px;
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.setting-btn {
  right: 20px;
}
.share-btn {
  right: 20px;
  top: 70px;
}
.user-info {
  display: flex;
  align-items: center;
  padding: 0 20px;
  /* margin-top: -30px; */
  position: relative;
  top: -30px;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid #fff;
  margin-right: 12px;
}
.info-text .username {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 8px;
}
.tags {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 8px;
}
.tags>img{
  width: 60px;
  /* height: 20px; */
}
.tag {
  background: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 12px;
}
.tag.vip {
  background: rgba(255,255,255,0.3);
}

/* 数据统计卡片 */
.stats-card {
  display: flex;
  background: #fff;
  margin: 0 20px;
  border-radius: 16px;
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  margin-top: -20px;
  position: relative;
  z-index: 1;
}
.stat-item {
  flex: 1;
  text-align: center;
}
.stat-item .num {
  font-size: 32px;
  font-weight: bold;
  margin: 0 0 4px;
}
.stat-item .label {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.num.orange { color: #ff7d00; }
.num.blue { color: #1677ff; }
.num.green { color: #0fb864; }
.num.purple { color: #722ed1; }

/* 菜单列表 */
.menu-section {
  margin: 20px;
  background: #fff;
  border-radius: 16px;
  padding: 16px;
}
.section-title {
  font-size: 16px;
  color: #999;
  margin: 0 0 16px;
}
.menu-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
}
.icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-wrap.orange { background: #fff2e8; }
.icon-wrap.green { background: #e6ffed; }
.icon-wrap.blue { background: #e6f7ff; }
.icon-wrap.purple { background: #f9f0ff; }
.icon-wrap.yellow { background: #fffbe6; }
.icon-wrap.cyan { background: #e6fffb; }
.icon-wrap.red { background: #fff2f0; }
.icon-wrap.gray { background: #f5f5f5; }
.text {
  flex: 1;
  font-size: 17px;
  color: #333;
}
.text-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.sub-text {
  font-size: 14px;
  color: #999;
  margin-top: 2px;
}
.badge {
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 10px;
}
.badge.orange { background: #fff2e8; color: #ff7d00; }
.badge.green { background: #e6ffed; color: #0fb864; }
.badge.blue { background: #e6f7ff; color: #1677ff; }
.badge.purple { background: #f9f0ff; color: #722ed1; }
.badge.yellow { background: #fffbe6; color: #faad14; }
.badge.red { background: #fff2f0; color: #f5222d; }
.dot {
  width: 10px;
  height: 10px;
  background: #f5222d;
  border-radius: 50%;
}
.arrow {
  flex-shrink: 0;
}

/* 退出登录按钮 */
.logout-btn {
  margin: 20px;
  background: #fff;
  color: #f5222d;
  text-align: center;
  padding: 16px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/mine.vue